import { render, staticRenderFns } from "./digit-f.vue?vue&type=template&id=5cd46032&"
import script from "./digit-f.vue?vue&type=script&lang=js&"
export * from "./digit-f.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports